export default __webpack_public_path__ + "static/4-bbd3531879f3177dd237c141e9564614.jpg";